export const normalizeLoginUsername = value => String(value || "").trim().toLowerCase();

export function loginFailureMessage(status, payload = {}, retryAfterHeader) {
  if (status === 401) return "Usuário ou senha incorretos.";
  if (status === 429) {
    const seconds = Number(payload.retryAfterSeconds || retryAfterHeader);
    if (Number.isFinite(seconds) && seconds > 0) {
      return `Muitas tentativas, aguarde ${Math.ceil(seconds / 60)} ${seconds <= 60 ? "minuto" : "minutos"}.`;
    }
    return "Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.";
  }
  return payload.error || "Não foi possível entrar agora. Tente novamente.";
}
